import React from 'react';
import Filters from '../../components/Filters';
import { Form } from 'react-bootstrap';
import MultiSelectField from '../../components/form/MultiSelectField';
import "react-datepicker/dist/react-datepicker.css";

const FiltersPartial = (props) => {
  const { filtersModel, setFiltersModel } = props;

  const onStatusAdded = (selectedItems, selectedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, statuses: [...(prevState?.statuses || []), selectedOption.id] }
    })
  }

  const onStatusRemove = (selectedItems, removedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, statuses: prevState.statuses.filter((id) => id !== removedOption.id) }
    })
  }

  return <Filters filtersModel={filtersModel} setFiltersModel={setFiltersModel}>
    <div>
      <Form.Group className="mb-3">
        <Form.Label>Status</Form.Label>
        <MultiSelectField
          options={[
            {
              id: 'pending',
              name: 'Pending'
            },
            {
              id: 'rejected',
              name: 'Rejected'
            },
            {
              id: 'approved',
              name: 'Approved'
            },
          ]}
          fieldName="statuses"
          stateModel={filtersModel}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={onStatusAdded}
          onRemove={onStatusRemove}
        />
      </Form.Group>
    </div>
  </Filters>
};

export default FiltersPartial;

